import { Button } from '@/shared/components'
import { ApplicationConsentSection } from '../ApplicationConsentSection'

type EligibilityConsentActionsProps = {
  checked: boolean
  disabled?: boolean
  error?: string
  isSubmitting: boolean
  onChange: (value: boolean) => void
  onRegister: () => void
  registerDisabled: boolean
}

export function EligibilityConsentActions({
  checked,
  disabled = false,
  error,
  isSubmitting,
  onChange,
  onRegister,
  registerDisabled
}: EligibilityConsentActionsProps) {
  return (
    <>
      <ApplicationConsentSection
        checked={checked}
        disabled={disabled}
        error={error}
        onChange={onChange}
      />
      <div className="mt-10 flex justify-center">
        <Button
          onClick={onRegister}
          loading={isSubmitting}
          disabled={registerDisabled}
          className="w-full max-w-[400px] transition-all duration-500 hover:-translate-y-0.5 active:translate-y-0 active:scale-95"
        >
          Register Now
        </Button>
      </div>
    </>
  )
}
